import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth';
import router from './router.js'
import * as logs from './assets/log_process.js'
import * as brc from './assets/breadcr.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // constants
//    rating_items: [100,90,83.33,80,75,70,66.67,60,50,40,33.33,30,25,20,16.66,14.28,12.5,11.11,10,5,0,-5,-10,-11.11,-12.5,-14.28,-16.66,-20,-25,-33.33,-30,-40,-50,-60,-66.67,-70,-75,-80,-83.33,-90,-100],
    rating_items: [-100,-90,-83.33,-80,-75,-70,-66.67,-60,-50,-40,-33.33,-30,-25,-20,-16.67,-14.29,-12.5,-11.11,-10,-5,0,5,10,11.11,12.5,14.29,16.67,20,25,30,33.33,40,50,60,66.67,70,75,80,83.33,90,100],
    // list of rules in all languages
    HTMLSystemRules : [],
    language_icons: [
      { id : 1,
        title: 'EN',
        url: require('@/assets/img/flags/ENG.svg'),
      },
      { id : 2,
        title: 'SK',
        url: require('@/assets/img/flags/SVK.svg'),
      },
      { id : 3,
        title: 'CS',
        url: require('@/assets/img/flags/CZE.svg'),
      },
      { id : 4,
        title: 'PL',
        url: require('@/assets/img/flags/POL.svg'),
      },
      { id : 5,
        title: 'ES',
        url: require('@/assets/img/flags/ESP.svg'),
      },
      { id : 6,
        title: 'HU',
        url: require('@/assets/img/flags/HUN.svg'),
      },
      { id : 7,
        title: 'NL',
        url: require('@/assets/img/flags/NLD.svg'),
      },
      { id : 8,
        title: 'RU',
        url: require('@/assets/img/flags/RUS.svg'),
      },
  ],
  systemPermissions : { // read from database in future
    system_content_creator : 1000,
    course_content_creator : 500,
    course_content_translator : 495,
    chapter_content_creator : 490,
    chapter_content_translator : 485,
    test_creator : 450,
    test_translator : 445,
    competition_creator : 400,
    competition_translator : 395,
    teacher : 200,
    assignment_creator : 100,
    admin : 10000
  },
    xContentData: { // for save data from extended content component
      forSave: [],
      data: [],
      updateList: []
    }, 

    token: null,
    isLogged: false,
    user: null,
    userPerformance: {
      xp: 0,
      coins: 0,
      level: 1,
      badges: []
    },
    axios_config: null,
    feedback : null,

    // skin/themes // os-preference / light / dark / colorblind
    theme_preference: 'light',

    // language data
    language_list: null,
    lang_primary_tmp: null,
    lang_secondary_tmp: null, // for translation
    lang_primary: null,
    lang_secondary: null, // for translation
    rule_index: null,
    
    // data lists
    full_content1: [],
    full_content24 : [],
    full_content567 : [],
    full_content8: [],
    full_content11: [],
    full_contentUni : [],
    ratings: [], // ratings in types 2-4
    files: [], // files in types 8...
    rules_globals: [], // list of rules in type 11
    
    // events support
    refresh1: false,
    refresh2: false,
    canDelete1: false,
    canDelete2: false,
    languageChanged: false,
    preparedforSave: false,
    showHelpEvent: false,
    showAnswerEvent: false,
    checkAnswerEvent: false,
    checkRatingEvent: false,
    saveBeforeDelete1 : false,
    saveBeforeDelete2 : false,

    saveCode : false,
    resetTask: false,
//    showCompileInfo : false,
//    showExecuteInfo : false,
    showDiscussion : false,
    testResults: null,
    compileInfo: null,
    vplProcessInfo : null,
//    nextBDOpp: -1,

    showErrorMessage: false,
    showDiscussionMessage: false,
    dataDiscussionMessage: null,
    answerID: 0,
    taskContentRatingShow:false,
    backDropShow:false,
    backDropMessage:false,
    showModalMessage:null,
    showModalMessageResult:null,
    showModalMessageText:'',
    waitingForResult:false,
    taskRating : -1,

    // answers
    transferAnswer : null,
        
    // events
    initData1: false,
    initData2: false,
    changedStore1 : false,
    changedStore2 : false,    
    addElement: false,
    deleteElement: 0,

    // status
    fakes: false,

    collapses: {
      a : false,
      b : false,
      c : false,
      d : false,
      e : false
    },

    // programs settings
    programElements : {
      assignment:  {
        show: true,
        collapse : true
      },
      files: {
        show: true,
        collapse : false
      },
      testCases: {
        show: true,
        collapse : false
      },
      filesToKeep : { // files as files in program, sql insert files
        show: true,
        collapse : false
      },
      configFiles: { // get from server on create type
        show: true,
        collapse : false
      },
      help: { 
        show: true,
        collapse : false
      }
    },
    programExtension : 'eee',
    editorType: '',

    breadCrumbs : [],

    queID: -1,

    countdownStatus: {
      count: 1800,
      id: -1,
      max: 1800
    },

    taskIndex: {
      showIndex: -1,
      editIndex: -1,
      vertic: true,
      preparedEdit: -1,
      changeVisibility : false, // of show index
      newVisibility : 0,
      newTranslated: -1
    },

    axiosRefresh: -1,
    socketTickets: null,
    startConsole : 0,
    consoleGrade: null,

    enviroViewNo: 0,
    fullScreen: 0,
    runCode: 0,

    enviroViewDimensions: new Map(),

    codeForRun : null,
    codeForRunAnswer: null,
    codeForRunKernel: null,
    //codeForRunToken: null,
    codeDeleteResults: false,
    codeKernelReset: false,
    codeInputData : {
      step: 0, // 0 - nothing, 1 - read from user, 2 - in process, running is blocked, 3 - send to kernel
      parentHeader: null,
      index: -1, // cell index
      inputText: '',
      data: ''
    },

    // student groups
    studentGroupsChanged: false,
    closeRevision: false,

    // essays
    essayReviewChanged: false,
    essayReviewData: null,

  },
//*********************************************************************** */
//*********************************************************************** */
  mutations: {
    cleanData(state) {
      state.full_content1 = []
      state.full_content24 = []
      state.full_content11 = []
      state.full_content567 = []
      state.full_content8 = []
      state.full_contentUni = []
    },
    //*********************************************************************** */
    setUserData(state, userData) {
      state.user = userData
      state.theme_preference = userData.theme_value
      state.userPerformance = userData.performance
      /* eslint-disable no-console */
      // console.log(userData)
      state.cleanData
    },
    setUserLanguage(state, data) {
      state.user.lang_id = data
    },
    setUserPerformance(state, data) {
      state.userPerformance = data
    },
    //*********************************************************************** */
    setConfig(state, data) {
      state.axios_config = {
        headers: {
          Authorization: 'Bearer ' + data
        }
      }
      state.token = data    
      state.isLogged = true
    },
    //*********************************************************************** */
    logout(state) {   
      logs.write_to_log('logout', '', 0, '', 0, 'manual', state.axios_config)  
      state.user = null      
      state.isLogged = false
      state.axios_config = null
      state.token = null
      localStorage.clear()
    },
    //*********************************************************************** */
    setFeedback(state, data) {
      // if (data)
       // state.feedback = data
       if ((data == null || data == '' )) state.showModalMessage = null
          else {
            if (data.response) {
              if (data.response.data == 'Unauthorized.') {
                  data = ''
                  state.user = null      
                  state.isLogged = false
                  state.axios_config = null
                  state.token = null
                  localStorage.clear()
                  router.replace({name : 'login'})
                  return
              }
            }
            state.showModalMessage =  {content: data, type: 'error', 
                                          buttons:[{text:'OK', value: 1}], icons:[]}
         }
    },  
    setQueId(state, data) {
      state.queID = data
    },
    setCountdownStatus(state, data) {
      state.countdownStatus = data
    },
    setCountdownDown(state) {
      state.countdownStatus.count--
    },
    //***********************************************************************
    setLanguageList(state, data) {
      state.language_list = data
    },
    //***********************************************************************
    setLangPrimary(state, data) {
      state.lang_primary = data
    },
    //***********************************************************************
    setLangSecondary(state, data) {
      state.lang_secondary = data
    },
    //***********************************************************************
    setLangPrimaryTmp(state, data) {
      state.lang_primary_tmp = data
    },
    //***********************************************************************
    setLangSecondaryTmp(state, data) {
      state.lang_secondary_tmp = data
    },
    //***********************************************************************
    setLogedOff(state) {
      state.isLogged = false
    },
    //***********************************************************************
    setContent1(state, data) {
      state.full_content1["l"+String(data.lang_id)] = data.content
    },
    //***********************************************************************
    setContent24(state, data) {
      state.full_content24["l"+String(data.lang_id)] = data.content
    },       
    //***********************************************************************
    setContent11(state, data) {
      state.full_content11["l"+String(data.lang_id)] = data.content
    },    
    //***********************************************************************
    setContent567(state, data) {
      state.full_content567["l"+String(data.lang_id)] = data.content
    },
    //***********************************************************************
    setContent8(state, data) {
      state.full_content8["l"+String(data.lang_id)] = data.content
    },    
    //***********************************************************************
    setContentUni(state, data) {
      state.full_contentUni["l"+String(data.lang_id)] = data.content
    },    
    //***********************************************************************
    setCanDelete1(state, data) {
      state.canDelete1 = data
    },    
    //***********************************************************************
    setCanDelete2(state, data) {
      state.canDelete2 = data
    },    
    //***********************************************************************
    setRefresh1(state, data) {
      state.refresh1 = data
      if (state.refresh1 && state.refresh2) 
        state.preparedforSave = true
    },
    //***********************************************************************
    setRefresh2(state, data) {
      state.refresh2 = data
      if (state.refresh1 && state.refresh2) 
        state.preparedforSave = true
    },    
    //***********************************************************************
    setLanguageChanged(state, data) {
      state.languageChanged = data
    },
    //***********************************************************************
    setInitData1(state, data) {
      state.initData1 = data
    },
    //***********************************************************************
    setInitData2(state, data) {
      state.initData2 = data
    },
    //***********************************************************************
    setSaveBeforeDelete1(state, data) {
      state.saveBeforeDelete1 = data
    },
    //***********************************************************************
    setSaveBeforeDelete2(state, data) {
      state.saveBeforeDelete2 = data
    },
    //***********************************************************************
    setAddElement(state, data) {
      state.addElement = data
    },
    //***********************************************************************
    setChangedStore1(state, data) {
      state.changedStore1 = data
    },
    //***********************************************************************
    setChangedStore2(state, data) {
      state.changedStore2 = data
    },
    //***********************************************************************
    setDeleteElement(state, data) {
      state.deleteElement = data
    },
    setProgramExtension(state,data) {
      state.programExtension = data
    },
    setEditorType(state,data) {
      state.editorType = data
    },
    //***********************************************************************
    setShowTaskIndex(state, data) {
      state.taskIndex.showIndex = data
    },
    setEditTaskIndex(state, data) {
      state.taskIndex.editIndex = data
    },
    setTaskVertic(state, data) {
      state.taskIndex.vertic = data
    },
    setTaskPreparedEdit(state, data) {
      state.taskIndex.preparedEdit = data
    },
    setTaskChangeVisibility(state, data) {
      state.taskIndex.changeVisibility = data
    },
    setTaskNewVisibility(state, data) {
      state.taskIndex.newVisibility = data
    },    
    setTaskNewTranslated(state, data) {
      state.taskIndex.newTranslated = data
    },
    setAxiosRefresh(state, data) {
      state.axiosRefresh = data
    },
    //***********************************************************************
    setThemePreference(state, data) {
      state.theme_preference = data
    },
    //***********************************************************************
    setHTMLSystemRules(state, data) { // set '' for all languages
      state.HTMLSystemRules = []
      for(let i = 0; i < state.language_list.length; i++) {
        state.HTMLSystemRules["l"+String(state.language_list[i].id)] = []
      }

      for(let i = 0; i < data.list.length; i++) {
        state.HTMLSystemRules["l"+String(data.list[i].lang_id)] = data.list[i].rules
      }

    },
    //***********************************************************************
    prepareContent1(state) { // set '' for all languages
      state.full_content1 = []
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content1["l"+String(state.language_list[i].id)] = ''        
      }
    },
    //***********************************************************************
    addAnswertoList24(state)    {
      state.ratings.push(0)
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)].answer_list.push({answer: '', feedback: ''})
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },    
      //***********************************************************************
      addRuletoList11(state, data)    {
        state.rules_globals.push(data.id)

        var start = 0

        for(let i = 0; i < state.language_list.length; i++) {
          var con = state.HTMLSystemRules["l"+String(state.language_list[i].id)][data.index]

          var c = con.text
          var res = []
          while (c.indexOf('####') > -1 || (c.indexOf('$$$$') > -1)) {
              // take first
              if (c.indexOf('####') > -1 && c.indexOf('$$$$') > -1) {
                    if (c.indexOf('####') < c.indexOf('$$$$')) {
                        start = c.indexOf('####')
                        // ## first
                        if (start == 0) {
                            res.push({ type: 'n', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 'n', text: ''})
                            c = c.substring(start+4)
                        }
                    } else {
                        // $$ first
                        start = c.indexOf('$$$$')
                        if (start == 0) {
                            res.push({ type: 't', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 't', text: ''})
                            c = c.substring(start+4)
                        }
                    }
              } else {
                  // ####
                  if (c.indexOf('####') > -1) {
                        start = c.indexOf('####')
                        // ## first
                        if (start == 0) {
                            res.push({ type: 'n', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 'n', text: ''})
                            c = c.substring(start+4)
                        }
                  }
                  // $$$$
                    if (c.indexOf('$$$$') > -1) {
                        start = c.indexOf('$$$$')
                        // ## first
                        if (start == 0) {
                            res.push({ type: 't', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 't', text: ''})
                            c = c.substring(start+4)
                        }
                  }
              }
          }
          if (c.length > 0) res.push( { type: 'c', text: c})
          let result = res
          state.full_content11["l"+String(state.language_list[i].id)].rules_list.push({rule_id: data.id, content: result, description : ''})
        }
        state.changedStore1 = true
        state.changedStore2 = true
      },  
    //***********************************************************************
    addFiletoList(state,data) {
      switch (data) {
        case 1: state.files.files.push('file' + (state.files.files.length+1)+'.' + state.programExtension)
                for(let i = 0; i < state.language_list.length; i++) {
                  state.full_content8["l"+String(state.language_list[i].id)].files.push({rContent: '', aContent: ''})
                }
                break
        case 2: state.files.filesToKeep.push('file' + (state.files.filesToKeep.length+1)+'.txt')
                for(let i = 0; i < state.language_list.length; i++) {
                  state.full_content8["l"+String(state.language_list[i].id)].filesToKeep.push('')
                }
                break
        case 3: state.files.configFiles.push('config' + (state.files.configFiles.length+1))
                for(let i = 0; i < state.language_list.length; i++) {
                  state.full_content8["l"+String(state.language_list[i].id)].configFiles.push('')
                }
                break  
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //***********************************************************************
    prepare24(state) {
      // rating
      state.ratings = [100]
      state.full_content24 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)] = {content:'', help:'', answer_list:[{answer: '', feedback: ''}]}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepare11(state) {
      // rating
      state.ratings = []
      state.full_content11 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content11["l"+String(state.language_list[i].id)] = { title: '', 
        assignment: '',
        requestedFile: '',
        authorsFile: '',
        help: '',
        rules_list: []}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //***********************************************************************
    prepare56(state) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', help:'', fakes:[]}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepare7(state) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', code:'', codes:'', help:''}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepareUni(state, cType) {
      state.full_contentUni = []

      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        if (cType == 'default') { state.full_contentUni["l"+String(state.language_list[i].id)] = { name : ''} }
        if (cType == 'course') { state.full_contentUni["l"+String(state.language_list[i].id)] = { name : '', description: '', detail: ''} }
      }

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepare8(state, data) {
      // visible and invisible parts
      state.programElements = data.visibility
      state.full_content8 = []

      if (data.type == 10) {
        state.files = {
          files : [ 'answer.sql'],
          filesToKeep: ['file1.txt'],
          configFiles: ['vpl_run.sh','vpl_debug.sh','vpl_evaluate.sh', 'createTables.sql', 'showResult.sql','correctAnswer.sql', 'dataset1.sql', 'dataset2.sql', 'dataset3.sql']
        }
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content8["l"+String(state.language_list[i].id)] = 
            {
                title: '',
                assignment: '',
                files: [{
                            rContent: '',
                            aContent : ''
                        }
                ],                     
                testCases: '',
                filesToKeep: [''],
                configFiles: ['','','','','','','','',''],
                help: ''                    
            }
        } 

      } else {
        state.files = {
          files : [ 'file1.' + data.extension ],
          filesToKeep: ['file1.txt'],
          configFiles: ['vpl_run.sh','vpl_debug.sh','vpl_evaluate.sh']
        }
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content8["l"+String(state.language_list[i].id)] = 
            {
                title: '',
                assignment: '',
                files: [{
                            rContent: '',
                            aContent : ''
                        }
                ],                     
                testCases: '',
                filesToKeep: [''],
                configFiles: ['','',''],
                help: ''                    
            }
        } 
      }
 
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //***********************************************************************
    setFakes(state, data) {
      state.fakes = data
    },
    //***********************************************************************
    setPreparedforSave(state, data) {
      state.preparedforSave = data
    },
    //***********************************************************************
    setRatings(state,data) {
      state.ratings = data
    },
    //***********************************************************************
    setRulesGlobals(state,data) {
      state.rules_globals = data
    },    //***********************************************************************
    setFiles(state,data) {
      state.files = data
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    setProgramElements(state, data) {
      state.programElements = data
    },
    //***********************************************************************
    setCollapses(state) {
      state.collapses = {a:true, b:false, c: false, d:false, e:false}
    },
    changeCollapse(state, data) {
      switch (data) {
        case 0 : state.collapses.a = !state.collapses.a
                 break
        case 1 : state.collapses.b = !state.collapses.b
                 break
        case 2 : state.collapses.c = !state.collapses.c
                 break
        case 3 : state.collapses.d = !state.collapses.d
                 break
        case 4 : state.collapses.e = !state.collapses.e
                 break
      }
    },
    setShowHelpEvent(state, data) {
      state.showHelpEvent = data
    },
    setShowAnswerEvent(state, data) {
      state.showAnswerEvent = data
    },
    setCheckAnswerEvent(state, data) {
      state.checkAnswerEvent = data
    },
    setCheckRatingEvent(state, data) {
      state.checkRatingEvent = data
    },
    setTransferAnswer(state,data) {
      state.transferAnswer = data
      state.checkRatingEvent = true // set for read in chapter content
    },
    setRuleIndex(state,data) {
      state.rule_index = data
    },
    setTaskContentRatingShow(state,data) {
      state.taskContentRatingShow = data
    },
    setBackDropShow(state,data) {
      state.backDropShow = data
    },
    setBackDropMessage(state,data) {
      state.backDropMessage = data
    },
    setShowModalMessage(state,data) {
      state.showModalMessage = data
    },
    setShowModalMessageResult(state,data) {
      state.showModalMessageResult = data
    },
    setShowModalMessageText(state,data) {
      state.showModalMessageText = data
    },    
    setWaitingForResult(state,data) {
      state.taskRating = -1
      state.waitingForResult = data
    },
    setTaskRating(state,data) {
        state.taskRating = (data >= 0) ? data : 0
    },
    setSaveCode(state,data) {
      state.saveCode = data
    },
    setResetTask(state,data) {
      state.resetTask = data
    },
/*     setShowCompileInfo(state,data) {
      state.showCompileInfo = data
    },
 */    setCompileInfo(state,data) {
      state.compileInfo = data
    },
/*     setShowExecuteInfo(state,data) {
      state.showExecuteInfo = data
    },
  */   setShowDiscussion(state,data) {
      state.showDiscussion = data
    },
    setShowErrorMessage(state,data) {
      state.showErrorMessage = data
    },
    setShowDiscussionMessage(state,data) {
      state.showDiscussionMessage = data
    },
    setDataDiscussionMessage(state, data) {
      state.dataDiscussionMessage = data
    },
    setAnswerID(state,data) {
      state.answerID = data
    },
    setTestResults(state, data) {
      state.testResults = data
    },
    setVplProcessInfo(state,data) {
      state.vplProcessInfo = data
    },
/*    setNextBDOpp(state,data) {
      state.nextBDOpp = data
    },
*/    setBreadCrumbs(state,data) {
      state.breadCrumbs = [ {text: 'Dashboard', href: '/dashboard' }, {text: 'Course list', href: '/categories' }] //#
      for(let i=0; i<data.length; i++) {
        if (data[i].text.length == 0) data[i].text = '<noname>'
        state.breadCrumbs.push(data[i])
      }
      document.title = 'Priscilla - ' + state.breadCrumbs[state.breadCrumbs.length - 1].text
    },
    setSocketTickets(state, data) {
      state.socketTickets = data
    },
    setStartConsole(state, data) {
      state.startConsole = data
    },
    setConsoleGrade(state, data) {
      state.consoleGrade = data
    },
    setEnviroViewNo(state) {
      state.enviroViewNo = (state.enviroViewNo + 1) % 6
    },
    setFullScreen(state, data) {
      state.fullScreen = data
    },
    setRunCode(state, data) {
      state.runCode = data
    },
    setEnviroViewDimensions(state, data) {
      localStorage.setItem('enviroViewDimensions', JSON.stringify(Array.from(new Map([...state.enviroViewDimensions, ...data]).entries())));
      state.enviroViewDimensions = new Map([...state.enviroViewDimensions, ...data])
    },
    // *** save data from extended component
    setSavePrepareListToEmpty(state) {
      state.xContentData.forSave = []
    },
    setSaveDataToEmpty(state) {
      state.xContentData.data = []
    },
    setUpdateListToEmpty(state) {
      state.xContentData.updateList = []
    },

    pushToSavePrepareList(state, data) {
      state.xContentData.forSave.push(data)
    },
    pushToUpdateList(state, data) {
      state.xContentData.updateList.push(data)
    },
    deleteFromUpdateList(state, data) {      
      const index = state.xContentData.updateList.indexOf(data)
      if (index > -1) {
        state.xContentData.updateList.splice(index,1)
      }
    },

    pushToSaveData(state, data) {
      // remove from savelist
      const index = state.xContentData.forSave.indexOf(data.id)
      if (index > -1) {
        state.xContentData.forSave.splice(index,1)
      } else { 
        console.log('problem ' + data)
      }

      // push to saved
      state.xContentData.data.push(data)
      // console.log(state.xContentData)
    },
    setCodeForRun(state, data) {
      state.codeForRun = data
    },
    setCodeForRunAnswer(state, data) {
      state.codeForRunAnswer = data
    },
    setCodeForRunKernel(state, data) {
      // state.codeForRunKernel = data
      // console.log('kernel write')
      // console.log(data)
      localStorage.setItem('kernel', JSON.stringify(data)) 
    },
/*     setCodeForRunToken(state, data) {
      state.codeForRunToken = data
    }, */
    setCodeDeleteResults(state, data) {
      state.codeDeleteResults = data
    },
    setCodeInputData(state, data) {
      state.codeInputData = data
    },
    setCodeKernelReset(state, data) {
      state.codeKernelReset = data
    },
    setStudentGroupsChanged(state, data) {
      state.studentGroupsChanged = data
    },
    setCloseRevision(state, data) {
      state.closeRevision = data
    },
    setEssayReviewChanged(state, data) {
      state.essayReviewChanged = data
    },
    setEssayReviewData(state, data) {
      state.essayReviewData = data
    },
  },

//*********************************************************************** */
//*********************************************************************** */
  actions: {
    //*********************************************************************** */
    login( {dispatch, commit, state}, authData ) {
      commit('setFeedback', null)
      axios.post('/oauth/token', authData)
      .then(res => {        
        // TOKEN TO LOCAL STORAGE
        localStorage.setItem('token', res.data.access_token) 
        // login to log
        commit('setConfig', res.data.access_token)
        axios.get('/get-full-user-parameters', state.axios_config)
        .then(res => {
            // set data to store
            commit('setUserData', res.data) 
            localStorage.setItem('role_id', res.data.role_id)
            localStorage.setItem('user_id', res.data.user_id)
         //   setTimeout(() => {
              dispatch('loadLanguageData')              
          //  }, 500); 
            router.replace({name : 'dashboard'})
        })
        .catch(() => {
          commit('setFeedback', 'Invalid autentification. Try again.')    
        })
      })
      .catch(() => {
        commit('setFeedback', "Access denied.")
      })
    },
    createEmptyAdminBreadCrumbs({commit, state, dispatch},id) {
      axios.get('/get-brc-for-task/' + id, state.axios_config )
      .then(res => {
          // set data to content                    
          dispatch('setAdminBreadCrumbs',res.data)
        })
      .catch(error => {
          commit('setFeedback', error)
      })
    },
    setAdminBreadCrumbs({commit},data) {
      commit('setBreadCrumbs',brc.createAdminBC(
        data.category.name, data.category.id,
        data.area.name, data.area.id,                    
        data.course.name, data.course.id,
        data.chapter.name, data.chapter.id,
        data.lesson.name, data.lesson.id                        
      ))  
    },

    //*********************************************************************** */
    tryAutologin({dispatch, commit, state}) {
      commit('setFeedback', null)
      if (localStorage == null) {
        router.replace({name : 'login'})
        return
      }
      state.token = localStorage.getItem('token')
      if (state.token) {
        commit('setConfig', state.token)
        axios.get('/get-full-user-parameters', state.axios_config)
        .then(res => {
            // set data to store
            commit('setUserData', res.data) 
           // commit('setUserPerformance', res.data.performance)                 
           // setTimeout(() => {
              dispatch('loadLanguageData')              
           // }, 500); 
        })
        .catch(() => {
          commit('logout')
          router.replace({name : 'login'})
        })
      } else {
        router.replace({name : 'login'})        
      }
    },
    //*********************************************************************** */
    logout({commit}) {
      commit('logout')
      router.replace({name : 'login'})
    },
    //*********************************************************************** */
    loadLanguageData( {commit, state}) {
      commit('setFeedback', null)
      axios.get('/languages')
        .then(res => {            
            // set data to store
            commit('setLanguageList', res.data) 
            // primary and secondary languages for translation
            var prim = res.data[0]
            var sec = res.data[1]
            for(let i = 1; i < res.data.length; i++) {
              if (res.data[i].id == state.user.lang_id) sec = res.data[i]
            }
            commit('setLangPrimary', prim)
            commit('setLangSecondary', sec)
            // add list of languages for admin creation 

            // translations for secondary lang
        })
        .catch((error) => {
          commit('setFeedback', error)
        })
      },
    //*********************************************************************** */
    deleteAnswerinList({state},data) {
      state.ratings.splice(data,1)
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)].answer_list.splice(data,1)
      }      
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //*********************************************************************** */
    deleteRuleinList({state},data) {
      state.rules_globals.splice(data,1)
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content11["l"+String(state.language_list[i].id)].rules_list.splice(data,1)
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //*********************************************************************** */
    deleteElementinList({state},data) {
      switch (data.tab) {
        case 1 :  state.files.files.splice(data.index,1)
                  for(let i = 0; i < state.language_list.length; i++) {
                    state.full_content8["l"+String(state.language_list[i].id)].files.splice(data.index,1)
                  } 
                  break
        case 2 :  state.files.filesToKeep.splice(data.index,1)
                  for(let i = 0; i < state.language_list.length; i++) {
                    state.full_content8["l"+String(state.language_list[i].id)].filesToKeep.splice(data.index,1)
                  } 
                  break
        case 3 :  state.files.configFiles.splice(data.index,1)
                  for(let i = 0; i < state.language_list.length; i++) {
                    state.full_content8["l"+String(state.language_list[i].id)].configFiles.splice(data.index,1)
                  } 
                  break
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },

    
    //***********************************************************************
    setFullContent24({state}, data) {
      // rating
      state.ratings = data.globals.ratings
      
      state.full_content24 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)] = {content:'', help:'', answer_list:[{answer: '', feedback: ''}]}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
       
        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)
        

          state.full_content24["l"+String(data.content_list[i].lang_id)] = {
            content: mycontent.content, 
            help: mycontent.help, 
            answer_list: mycontent.answer_list 
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    setFullContent11({state}, data) {
      // rating
      state.rules_globals = data.globals.globals

      state.full_content11 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content11["l"+String(state.language_list[i].id)] = { title: '', 
                                                                        assignment: '',
                                                                        requestedFile: '',
                                                                        authorsFile: '',
                                                                        help: '',
                                                                        rules_list: []}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
       
        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)
        

          state.full_content11["l"+String(data.content_list[i].lang_id)] = {
            title: mycontent.title, 
            assignment: mycontent.assignment, 
            requestedFile: mycontent.requestedFile, 
            authorsFile: mycontent.authorsFile, 
            help: mycontent.help, 
            rules_list: mycontent.rules_list 
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },



    //***********************************************************************

    setFullContent56({state}, data) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', help:'', fakes:[]}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {

        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)

          state.full_content567["l"+String(data.content_list[i].lang_id)] = {
            content: mycontent.content, 
            help: mycontent.help, 
            fakes: mycontent.fakes 
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //************************************************************* */
    setFullContent7({state}, data) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', code:'', codes:'', help:''}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {       
        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)

          state.full_content567["l"+String(data.content_list[i].lang_id)] = {
            content: mycontent.content, 
            code: mycontent.code, 
            codes: mycontent.codes, 
            help: mycontent.help
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //************************************************************* */
    setFullContentUni({commit, state}, data) {
      commit('prepareUni',data.cType)
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
        if (data.cType == 'default') { 
           state.full_contentUni["l"+String(data.content_list[i].lang_id)] = { name: data.content_list[i].name } 
          }
        if (data.cType == 'course') { 
          state.full_contentUni["l"+String(data.content_list[i].lang_id)] = { 
                                                                              name: data.content_list[i].name, 
                                                                              description: data.content_list[i].description, 
                                                                              detail: data.content_list[i].detail 
                                                                            } 
          }
 
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //********************************************************************* */
    setFullContent8({state}, data) {
      // visible and invisible parts
      state.programElements = data.settings
      
      // names of files
      state.files = data.globals.files

      state.full_content8 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content8["l"+String(state.language_list[i].id)] = 
          {
              title: '',
              assignment: '',
              files: [{
                          rContent: '',
                          aContent : ''
                      }
              ],                     
              testCases: '',
              filesToKeep: [''],
              configFiles: [''],
              help: ''                    
          }
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {

        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)

          state.full_content8["l"+String(data.content_list[i].lang_id)] = mycontent
          if (state.full_content8["l"+String(data.content_list[i].lang_id)].filesToKeep.length == 0) {
            state.full_content8["l"+String(data.content_list[i].lang_id)].filesToKeep.push('')
          }
          if (state.full_content8["l"+String(data.content_list[i].lang_id)].configFiles.length == 0) {
            state.full_content8["l"+String(data.content_list[i].lang_id)].configFiles.push('')
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },   
    /*
    setActiveCategory(state, data) {
      let record = {
        activeCategory : data,
        activeArea : 0,
        activeCourse : 0,
        activeChapter : 0,
        activeLesson : 0,
        activeMicro : 0
      }
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveCourseDetails(getters,data) {
      let rr = {
        activeCategory : {id : data.category.id, name: data.category.name},
        activeArea : {id : data.area.id, name: data.area.name},
        activeCourse : {id : data.course.id, name: data.course.name},
        activeChapter : 0,
        activeLesson : 0,
        activeMicro : 0
      }
      localStorage.setItem('position', JSON.stringify(rr))      
    },
    setActiveArea(getters,data) {
      let rr = JSON.parse(localStorage.getItem('position'))
      rr.activeArea = { id: data.id, name: data.name}
      rr.activeCourse = 0
      rr.activeChapter = 0
      rr.activeLesson = 0
      rr.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(rr))      
    },
    setActiveCourse(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeCourse = { id: data.id, name: data.name}
      record.activeChapter = 0
      record.activeLesson = 0
      record.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveChapter(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeChapter = { id: data.id, name: data.name}
      record.activeLesson = 0
      record.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveLesson(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeLesson = { id: data.id, name: data.name}
      record.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveMicro(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeMicro = { id: data.id, name: data.name}
      localStorage.setItem('position', JSON.stringify(record))
    }
    */
  },
//*********************************************************************** */
//*********************************************************************** */
  getters: {
    user (state) {
      return state.user
    },
    //*********************************************************************** */
    getAxiosConfig (state) {
      return state.axios_config
    },   
     //*********************************************************************** */
    getFeedback (state) {
      return state.feedback
    },
    //*********************************************************************** */
    isLogged(state) {   
      return state.isLogged
    },
    //*********************************************************************** */
      isAdmin(state) {
        if(state.user) {
          return state.user.role_id == 2
        } else {
          return false
        }
      },
    //*********************************************************************** */
    getLanguageList(state) {
      return state.language_list
    },
    //*********************************************************************** */
    getLanguagePrimary(state) {
      if (state.lang_primary)
        return state.lang_primary
      else
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //*********************************************************************** */
    getLanguageSecondary(state) {
      if (state.lang_secondary)
        return state.lang_secondary
      else 
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //*********************************************************************** */
    getLanguagePrimaryTmp(state) {
      if (state.lang_primary_tmp)
        return state.lang_primary_tmp
      else
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //*********************************************************************** */
    getLanguageSecondaryTmp(state) {
      if (state.lang_secondary_tmp)
        return state.lang_secondary_tmp
      else 
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //***********************************************************************
    getContent1: (state) => (lang_id) => {
        return state.full_content1["l"+String(lang_id)]
    },
    //***********************************************************************
    getContent24: (state) => (lang_id) => {
        return state.full_content24["l"+String(lang_id)]
    },
    //***********************************************************************
    getContent11: (state) => (lang_id) => {
      return state.full_content11["l"+String(lang_id)]
    },    
    //***********************************************************************
    getContent567: (state) => (lang_id) => {
      return state.full_content567["l"+String(lang_id)]
    },    
    //***********************************************************************
    getContent8: (state) => (lang_id) => {
      return state.full_content8["l"+String(lang_id)]
    },    
    //***********************************************************************
    getContentUni: (state) => (lang_id) => {
      return state.full_contentUni["l"+String(lang_id)]
    },    
    //***********************************************************************
    getAllContent1 (state) {
      return state.full_content1
    },
    //***********************************************************************
    getAllContent24 (state) {
      return state.full_content24
    },
    //***********************************************************************
    getAllContent11 (state) {
      return state.full_content11
    },
    //***********************************************************************
    getAllContent567 (state) {
      return state.full_content567
    },    
    //***********************************************************************
    getAllContent8 (state) {
      return state.full_content8
    },
    //***********************************************************************
    getAllContentUni (state) {
      return state.full_contentUni
    },
    //*********************************************************************** */
    getRefresh1(state) {
      return state.refresh1
    },
    //*********************************************************************** */
    getRefresh2(state) {
      return state.refresh2
    },    
    //*********************************************************************** */
    getInitData1(state) {
      return state.initData1
    },
    //*********************************************************************** */
    getInitData2(state) {
      return state.initData2
    },
    //*********************************************************************** */
    getChangedStore1(state) {
      return state.changedStore1
    },
    //*********************************************************************** */
    getChangedStore2(state) {
      return state.changedStore2
    },
    //*********************************************************************** */
    getAddElement(state) {
      return state.addElement
    },
    //*********************************************************************** */
    getDeleteElement(state) {
      return state.deleteElement
    },
    //*********************************************************************** */
    getLanguageChanged(state) {
      return state.languageChanged
    },
    //*********************************************************************** */
    getPreparedforSave(state) {
      return !(state.refresh1 || state.refresh2)    
    },
    //*********************************************************************** */
    getRatingItems(state) {
      return state.rating_items
    },
    //*********************************************************************** */
    getRatings(state) {
      return state.ratings
    },
    //*********************************************************************** */
    getFiles(state) {
      return state.files
    },
    //***********************************************************************
    missingData(state) {
      return (state.user == null || state.language_list == null)
    },
    //***********************************************************************
    getFakes(state) {
      return state.fakes
    },
    //********************************************************************** */
    getProgramElements(state) {
      return state.programElements
    },
    //********************************************************************** */
    getCollapses(state) {
      return state.collapses
    },
    //********************************************************************** */
    getShowHelpEvent(state) {
      return state.showHelpEvent
    },
    getShowAnswerEvent(state) {
      return state.showAnswerEvent
    },
    getCheckAnswerEvent(state) {
      return state.checkAnswerEvent
    },
    getCheckRatingEvent(state) {
      return state.checkRatingEvent
    },
    getTransferAnswer(state) {
      return state.transferAnswer
    },
    getThemePreference(state) {
      return state.theme_preference
    },
    isDarkMode(state) {
      if (state.theme_preference == 'os-preference') {
          const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
          if (prefersDarkScheme.matches) {
              return true
          }
          // pokial je zvolena OS preferencia - kontrolujeme ci pocas behu nebola zmenena téma
          window.matchMedia('(prefers-color-scheme: dark)')
              .addEventListener('change', event => {
                  if (event.matches) {
                      return true
                  }
              })
          return false
      } else if (state.theme_preference == 'dark') {
          return true
      } else if (state.theme_preference == 'light' || state.theme_preference == 'colorblind') {
          return false
      }
    },
    getHTMLSystemRules(state) {
      return state.HTMLSystemRules
    },
    getRulesGlobals(state) {
      return state.rules_globals
    },
    getRuleIndex(state) {
      return state.rule_index
    },
      //************************************************************ */
/*      parseRules(state, content) {        
        var c = content.text
        var res = []
        var start = 0
        while (c.indexOf('####') > -1 || (c.indexOf('$$$$') > -1)) {
            // take first
            if (c.indexOf('####') > -1 && c.indexOf('$$$$') > -1) {
                  if (c.indexOf('####') < c.indexOf('$$$$')) {
                      start = c.indexOf('####')
                      // ## first
                      if (start == 0) {
                          res.push({ type: 'n', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 'n', text: ''})
                          c = c.substring(start+4)
                      }
                  } else {
                      // $$ first
                      start = c.indexOf('$$$$')
                      if (start == 0) {
                          res.push({ type: 't', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 't', text: ''})
                          c = c.substring(start+4)
                      }
                  }
            } else {
                // ####
                if (c.indexOf('####') > -1) {
                      start = c.indexOf('####')
                      // ## first
                      if (start == 0) {
                          res.push({ type: 'n', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 'n', text: ''})
                          c = c.substring(start+4)
                      }
                }
                // $$$$
                  if (c.indexOf('$$$$') > -1) {
                      start = c.indexOf('$$$$')
                      // ## first
                      if (start == 0) {
                          res.push({ type: 't', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 't', text: ''})
                          c = c.substring(start+4)
                      }
                }
            }
        }
        if (c.length > 0) res.push( { type: 'c', text: c})
        return res
      },
*/    //***********************************************************************
    getCanDelete1(state) {
      return state.canDelete1
    },    
    //***********************************************************************
    getCanDelete2(state) {
      return state.canDelete2
    },
    //***********************************************************************
    getSaveBeforeDelete1(state) {
      return state.saveBeforeDelete1 
    },
    //***********************************************************************
    getSaveBeforeDelete2(state) {
      return state.saveBeforeDelete2
    },
    getUserID() {
      return localStorage.getItem('user_id')
    },
    getCountdownStatus(state) {
      return state.countdownStatus
    },
    getEditorType(state) {
      return state.editorType
    },
    getTaskContentRatingShow(state) {
      return state.taskContentRatingShow
    },
    getBackDropShow(state) {
      return state.backDropShow
    },
    getBackDropMessage(state) {
      return state.backDropMessage
    },
    getShowModalMessage(state) {
      return state.showModalMessage
    },
    getShowModalMessageResult(state){
      return state.showModalMessageResult
    },
    getShowModalMessageText(state){
      return state.showModalMessageText
    },    
    getWaitingForResult(state) {
      return state.waitingForResult
    },
    getTaskRating(state) {
      return state.taskRating
    },
    getUserPerformance(state) {
      return state.userPerformance
    },
    getSaveCode(state) {
      return state.saveCode
    },
    getResetTask(state) {
      return state.resetTask
    },
/*    getShowCompileInfo(state) {
      return state.showCompileInfo
    },
*/    getCompileInfo(state) {
      return state.compileInfo
    },
/*    getShowExecuteInfo(state) {
      return state.showExecuteInfo
    },
*/    getShowDiscussion(state) {
      return state.showDiscussion
    },
    getTestResults(state) {
      return state.testResults
    },
    getVplProcessInfo(state) {
      return state.vplProcessInfo
    },
/*    getNextBDOpp(state) {
      return state.nextBDOpp
    },    
*/    getBreadCrumbs(state) {
      return state.breadCrumbs
    },
    getShowErrorMessage(state) {
      return state.showErrorMessage
    },    
    getShowDiscussionMessage(state) {
      return state.showDiscussionMessage
    },
    getAnswerID(state) {
      return state.answerID
    },
    getDataDiscussionMessage(state) {
      return state.dataDiscussionMessage
    },
    getLanguageIcons(state) {
      return state.language_icons
    },
    getQueId(state) {
      return state.queID
    },
    getSystemPermissions(state) {
      return state.systemPermissions
    },
    //****************** tak component */
    getTaskVertic(state) {
      return state.taskIndex.vertic
    },
    getTaskPreparedEdit(state) {
      return state.taskIndex.preparedEdit
    },
    getTaskChangeVisibility(state) {
      return state.taskIndex.changeVisibility
    },
    getTaskNewVisibility(state) {
      return state.taskIndex.newVisibility
    },
    getTaskNewTranslated(state) {
      return state.taskIndex.newTranslated
    },
    getAxiosRefresh(state) {
      return state.axiosRefresh
    },
    getSocketTickets(state) {
      return state.socketTickets
    },
    getStartConsole(state) {
      return state.startConsole
    },
    getConsoleGrade(state) {
      return state.consoleGrade
    },
    getEnviroViewNo(state) {
      return state.enviroViewNo
    },
    getFullScreen(state) {
      return state.fullScreen
    },
    getRunCode(state) {
      return state.runCode
    },
    getEnviroViewDimensions(state) {
      if (localStorage.getItem('enviroViewDimensions')) {
        state.enviroViewDimensions = new Map(JSON.parse(localStorage.getItem('enviroViewDimensions')));
      }
      return state.enviroViewDimensions
    },
    // *** save data from extended component
    getSavePrepareList(state) {
      return state.xContentData.forSave
    },
    getSaveData(state) {
      return state.xContentData.data
    },
    getUpdateList(state) {
      return state.xContentData.updateList
    },
    //******************* for vue 3 */
    getShowTaskIndex(state) {
      return parseInt(state.taskIndex.showIndex)
    },
    getEditTaskIndex(state) {
      return parseInt(state.taskIndex.editIndex)
    },
    getCodeForRun(state) {
      return state.codeForRun
    },
    getCodeForRunAnswer(state) {
      return state.codeForRunAnswer
    },
    getCodeForRunKernel(state) {
      return JSON.parse(localStorage.getItem('kernel'))      
    },
/*     getCodeForRunToken(state) {
      return state.codeForRunToken
    }, */
    getCodeDeleteResults(state) {
      return state.codeDeleteResults
    },
    getCodeInputData(state) {
      return state.codeInputData
    },
    getCodeKernelReset(state) {
      return state.codeKernelReset
    },
    getStudentGroupsChanged(state) {
      return state.studentGroupsChanged
    },
    getCloseRevision(state) {
      return state.closeRevision
    },
    getEssayReviewChanged(state) {
      return state.essayReviewChanged
    },
    getEssayReviewData(state) {
      return state.essayReviewData
    },


}
})